import { render, staticRenderFns } from "./AddIdentityPool.vue?vue&type=template&id=6efe6561&scoped=true&"
import script from "./AddIdentityPool.vue?vue&type=script&lang=js&"
export * from "./AddIdentityPool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efe6561",
  null
  
)

export default component.exports